import { render, staticRenderFns } from "./HighlightsInstagramIcon.vue?vue&type=template&id=0b9d69b1"
import script from "./HighlightsInstagramIcon.vue?vue&type=script&lang=ts"
export * from "./HighlightsInstagramIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports